<template>
    <div>
        <design2021-apprentice-data-table
            class="enrolled-internships"
            :items="tableData"
            :fields="studentFields"
            show-empty>
            <template v-slot:options>
                <div v-if="maxedOut">
                    {{ $t('internship.maximum_number_of_students_has_been_reached_this_includes_registrations') }}
                </div>
                <b-button
                    class="btn-add btn-add-students"
                    v-b-modal="'add-student-modal'"
                    variant="primary"
                    :disabled="maxedOut">
                    {{ $t('internship.add_student') }}
                </b-button>
            </template>

            <template v-slot:cell(motivation)="data">
                <b-button
                    class="btn-clipboard remove-icon-margin"
                    v-if="data.item.motivation != null"
                    v-b-tooltip:hover
                    variant="primary-icon-only"
                    :title="$t('internship.view_motivation')"
                    @click="openMotivationModal(data.item.motivation)">
                </b-button>
            </template>

            <template v-slot:cell(signedInternshipAgreement)="data">
                <b-button
                    class="btn-file-alt remove-icon-margin"
                    v-if="data.item.signedInternshipAgreement"
                    variant="primary-icon-only"
                    @click="downloadSignedInternshipAgreement(data.item.signedInternshipAgreement.path)"></b-button>
            </template>
            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-sign-out btn-module-sign-out remove-icon-margin"
                    v-b-tooltip.hover
                    variant="danger-icon-only"
                    :title="$t('common.delete')"
                    @click="openSignOutModal(data.item.id)">
                </b-button>
            </template>

            <template #empty="scope">
                <div class="not-found with-header empty-student-list">
                    <div class="icon">
                        <i
                            class="fas fa-exclamation-circle"
                            data-v-e13f5460=""></i>
                    </div>
                    <div class="alert-notice">{{ $t('internship.no_participants_found') }}</div>
                </div>
            </template>
        </design2021-apprentice-data-table>
        <design-2021-internship-edit-student-tab-add-modal-component
            @addStudent="addStudent($event)"
            ref="add-student-modal"
            :internship-in="internshipIn"
            :students-in="studentsIn"
            :student-id-array-in="studentIdArrayIn">
        </design-2021-internship-edit-student-tab-add-modal-component>

        <design-2021-internship-edit-enrolled-students-tab-signout-modal-component
            @signout="signOut($event)"
            ref="signout-student-modal"
            :internship-in="this.internship">
        </design-2021-internship-edit-enrolled-students-tab-signout-modal-component>

        <design-2021-internship-edit-students-tab-motivation-modal-component ref="motivation-modal">
        </design-2021-internship-edit-students-tab-motivation-modal-component>
    </div>
</template>

<script>
import Design2021ApprenticeDataTable from '../../../common/design-2021-apprentice-data-table';

export default {
    name: 'design-2021-internships-edit-enrolled-students-tab-component',
    components: { Design2021ApprenticeDataTable },
    props: ['internshipIn', 'enrolledStudentsIn', 'studentIdArrayIn', 'studentsIn'],
    data() {
        return {
            internship: this.internshipIn,
            enrolledStudents: this.enrolledStudentsIn,
            studentFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                },
                {
                    key: 'motivation',
                    label: this.$t('internship.motivation'),
                },
                {
                    key: 'signedInternshipAgreement',
                    label: this.$t('internship.internship_agreement'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.enrolledStudentsIn.map((student) => {
                return {
                    id: student.id,
                    name: student.full_name,
                    email: student.email,
                    motivation: student.pivot.motivation,
                    signedInternshipAgreement: student.signed_internship_agreements[0]
                        ? student.signed_internship_agreements.map((agreement) => agreement.file)[0]
                        : null,
                };
            });
        },
        maxedOut() {
            return this.studentsIn.length >= this.internshipIn.slots;
        },
    },
    methods: {
        addStudent(student) {
            this.$emit('addStudent', student);
        },
        signOut(userId) {
            this.enrolledStudents = this.tableData.filter((item) => item.id !== userId);
            this.$emit('signout', userId);
        },
        openSignOutModal(userId) {
            this.$refs['signout-student-modal'].show(userId);
        },
        resetLoadedUsersTofalse() {
            this.$refs['add-student-modal'].resetLoadedTofalse();
        },
        openMotivationModal(motivation) {
            this.$refs['motivation-modal'].show(motivation);
        },
        downloadSignedInternshipAgreement(path) {
            window.open(path, '_blank');
        },
    },
};
</script>

<style scoped lang="scss">
@media (min-width: map-get($grid-breakpoints, 'md')) {
    .enrolled-internships ::v-deep {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters {
                flex: 1 1 auto;
                margin-bottom: 0;
            }

            .options {
                margin-left: auto;
                justify-content: flex-end;
                flex: 1 1 auto;
            }
        }
    }
}
</style>
